define.alias("ember-power-select/components/power-select/before-options", "settings/components/power-select/before-options");